module.exports = __webpack_public_path__ + "static/media/1040313500.83768dcf.jpg";